import { scheduleDateIso } from './nextMovement';

const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function buildMonthsInRange(fromIso, toIso) {
  if (!fromIso || !toIso || fromIso > toIso) return [];
  const [startY, startM] = fromIso.split('-').map(Number);
  const [endY, endM] = toIso.split('-').map(Number);
  const months = [];
  let y = startY;
  let m = startM;
  while (y < endY || (y === endY && m <= endM)) {
    months.push({ year: y, month: m });
    m += 1;
    if (m > 12) {
      m = 1;
      y += 1;
    }
  }
  return months;
}

export function indexScheduleByDate(scheduleRows) {
  const byDate = new Map();
  (scheduleRows || []).forEach((row) => {
    const iso = scheduleDateIso(row);
    if (iso) byDate.set(iso, row);
  });
  return byDate;
}

function toIsoDate(year, month, day) {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function formatMonthTitle(year, month) {
  const dt = new Date(year, month - 1, 1);
  return dt.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export function buildMonthWeeks(year, month, scheduleByDate) {
  const daysInMonth = new Date(year, month, 0).getDate();
  const firstWeekday = new Date(year, month - 1, 1).getDay();
  const weeks = [];
  let week = [];

  for (let i = 0; i < firstWeekday; i += 1) {
    week.push({ date: null, schedule: null, inRange: false });
  }

  for (let day = 1; day <= daysInMonth; day += 1) {
    const date = toIsoDate(year, month, day);
    week.push({
      date,
      schedule: scheduleByDate.get(date) ?? null,
      inRange: true,
    });
    if (week.length === 7) {
      weeks.push(week);
      week = [];
    }
  }

  if (week.length > 0) {
    while (week.length < 7) {
      week.push({ date: null, schedule: null, inRange: false });
    }
    weeks.push(week);
  }

  return weeks;
}

export { WEEKDAY_LABELS };
